import { render, staticRenderFns } from "./label-dialog.vue?vue&type=template&id=7225b356&"
import script from "./label-dialog.vue?vue&type=script&lang=js&"
export * from "./label-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports